import { QueryClient } from '@tanstack/react-query';

// Singleton QueryClient instance
let queryClientInstance = null;

// Create a singleton QueryClient instance
export const queryClient = (() => {
    if (!queryClientInstance) {
        queryClientInstance = new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: 5 * 60 * 1000, // 5 minutes
                    refetchOnWindowFocus: false,
                    retry: 3,
                },
                mutations: {
                    retry: 1,
                },
            },
        });
    }
    return queryClientInstance;
})();
